import type { ButtonProps } from './const';
import classNames from 'classnames';
import { forwardRef } from 'react';
import Loading from '../Loading';
import './index.less';

function Button(props: ButtonProps, ref: React.Ref<HTMLButtonElement>) {
  const {
    type = 'primary',
    status,
    style,
    className = '',
    children,
    size = 'default',
    disabled,
    loading,
    block,
    onClick,
    icon,
    childrenClassName = '',
    ...rest
  } = props;
  const handleButtonClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (loading || disabled) {
      return;
    }
    onClick && onClick(e);
  };
  return (
    <button
      {...rest}
      ref={ref}
      type="button"
      disabled={disabled || loading}
      data-disabled={disabled}
      style={{ ...style }}
      className={classNames(
        ['wg-button', `wg-button-${type}`, `wg-button-size-${size}`],
        {
          [`wg-button-status-${status}`]: !!status,
          [`wg-button-block`]: block,
          [`wg-button-loading`]: loading,
          [`wg-button-disabled`]: disabled,
          [`wg-button-only-icon`]: !!icon && !children,
        },
        className,
      )}
      onClick={handleButtonClick}
    >
      <div className="wg-button-content" style={{ opacity: loading ? 0 : 1 }}>
        {icon && <div className="wg-button-icon">{icon}</div>}
        {children && <div className={classNames(['wg-button-children', childrenClassName])}>{children}</div>}
      </div>
      {loading && <Loading block className="wg-button-loading" color="inherit" />}
    </button>
  );
}

const ButtonComponent = forwardRef<HTMLButtonElement, ButtonProps>(Button);

ButtonComponent.displayName = 'Button';

export default ButtonComponent;

export type { ButtonProps };
